module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = "<%\n  var utils = require('../utils');\n  var NetSimUtils = require('./NetSimUtils');\n\n  /**\n  * This block destructures the local variables for use within this ejs template.\n  */\n  var uptime = locals.uptime;\n  var queuedPackets = locals.queuedPackets;\n  var totalPackets = locals.totalPackets;\n  var successfulPackets = locals.successfulPackets;\n  var totalData = locals.totalData;\n  var successfulData = locals.successfulData;\n  var bandwidthLimit = locals.bandwidthLimit;\n  var dataRate = locals.dataRate;\n  var totalMemory = locals.totalMemory;\n  var usedMemory = locals.usedMemory;\n\n  /**\n   * Write a stats row with the given title and value.\n   * @param {string} title - localized name of the statistic (the header column contents)\n   * @param {*} statValue - the value of the statistic\n   */\n  var writeStatRow = function (title, statValue) {\n    %>\n      <tr>\n        <th nowrap><%= title %></th>\n        <td><%= statValue %></td>\n      </tr>\n    <%\n  };\n\n  /**\n   * Write a stats row that displays a fraction and also its percentage form.\n   * @param {string} title - localized name of the statistic (the header column contents)\n   * @param {number} partValue - numerator of the stat\n   * @param {number} totalValue - denominator of the stat\n   * @param {function} [toStringFunction] method for converting numerator and denominator to display format\n   */\n  var fractionStatRow = function (title, partValue, totalValue, toStringFunction) {\n    toStringFunction = utils.valueOr(toStringFunction, function (x) { return x; });\n    var valueString = toStringFunction(partValue) + ' / ' + toStringFunction(totalValue);\n    if (totalValue > 0 && totalValue < Infinity) {\n      valueString += ' (' + Math.round(100 * partValue / totalValue) + '%)';\n    }\n    writeStatRow(title, valueString);\n  };\n%>\n<table>\n  <tbody>\n    <% writeStatRow('Uptime', uptime); %>\n    <% writeStatRow('Queued Packets', queuedPackets); %>\n    <% fractionStatRow('Memory Use', usedMemory, totalMemory, NetSimUtils.bitsToLocalizedRoundedBytesize); %>\n    <% fractionStatRow('Throughput', dataRate, bandwidthLimit, NetSimUtils.bitrateToLocalizedRoundedBitrate); %>\n    <% fractionStatRow('Routed Packets', successfulPackets, totalPackets); %>\n    <% fractionStatRow('Routed Data', successfulData, totalData, NetSimUtils.bitsToLocalizedRoundedBytesize); %>\n  </tbody>\n</table>\n", __filename = "src/netsim/NetSimRouterStatsTable.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var utils = require("../utils");
        var NetSimUtils = require("./NetSimUtils");
        var uptime = locals.uptime;
        var queuedPackets = locals.queuedPackets;
        var totalPackets = locals.totalPackets;
        var successfulPackets = locals.successfulPackets;
        var totalData = locals.totalData;
        var successfulData = locals.successfulData;
        var bandwidthLimit = locals.bandwidthLimit;
        var dataRate = locals.dataRate;
        var totalMemory = locals.totalMemory;
        var usedMemory = locals.usedMemory;
        var writeStatRow = function(title, statValue) {
            __line = 25;
            __append("\n      <tr>\n        <th nowrap>");
            __line = 27;
            __append(escapeFn(title));
            __append("</th>\n        <td>");
            __line = 28;
            __append(escapeFn(statValue));
            __append("</td>\n      </tr>\n    ");
            __line = 30;
        };
        var fractionStatRow = function(title, partValue, totalValue, toStringFunction) {
            toStringFunction = utils.valueOr(toStringFunction, function(x) {
                return x;
            });
            var valueString = toStringFunction(partValue) + " / " + toStringFunction(totalValue);
            if (totalValue > 0 && totalValue < Infinity) {
                valueString += " (" + Math.round(100 * partValue / totalValue) + "%)";
            }
            writeStatRow(title, valueString);
        };
        __line = 48;
        __append("\n<table>\n  <tbody>\n    ");
        __line = 51;
        writeStatRow("Uptime", uptime);
        __append("\n    ");
        __line = 52;
        writeStatRow("Queued Packets", queuedPackets);
        __append("\n    ");
        __line = 53;
        fractionStatRow("Memory Use", usedMemory, totalMemory, NetSimUtils.bitsToLocalizedRoundedBytesize);
        __append("\n    ");
        __line = 54;
        fractionStatRow("Throughput", dataRate, bandwidthLimit, NetSimUtils.bitrateToLocalizedRoundedBitrate);
        __append("\n    ");
        __line = 55;
        fractionStatRow("Routed Packets", successfulPackets, totalPackets);
        __append("\n    ");
        __line = 56;
        fractionStatRow("Routed Data", successfulData, totalData, NetSimUtils.bitsToLocalizedRoundedBytesize);
        __append("\n  </tbody>\n</table>\n");
        __line = 59;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}